<template>
  <div> <!-- Element rădăcină -->
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('gestiune.outputs')"></general-top-bar> -->
      <div id="outer-container">
          <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
              <div class="card-content">
                  <div class="clearfix row pad-lf-10 pad-rg-10">
                      <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isBonFiscal }"
                        @click="openBonFiscal"
                      >{{$t('gestiune.sales')}}</a>
                      <a
                        v-if="userHasRight('can_generate_invoice')"
                        class="btn btn-fill btn-primary"
                        :class="{ active: isInvoice }"
                        @click="openInvoice"
                      >{{$t('invoice.invoices')}}</a>
                      <a
                        v-if="userHasRight('can_generate_invoice')"
                        class="btn btn-fill btn-primary"
                        :class="{ active: isProforma }"
                        @click="openProforma"
                      >{{$t('invoice.proforma')}}</a>
                      <a
                        v-if="userHasRight('can_generate_aviz')"
                        class="btn btn-fill btn-primary"
                        :class="{ active: isAviz }"
                        @click="openAviz"
                      >{{$t('gestiune.aviz')}}</a>
                  </div>
              </div>
          </div>
      </div>
      <div v-if="isBonFiscal">
        <ManagementBonFiscal :groupedLocations="groupedLocations"/>
      </div>
      <div v-if="isInvoice && userHasRight('can_generate_invoice')">
        <Invoice :groupedLocations="groupedLocations"/>
      </div>
      <div v-if="isProforma && userHasRight('can_generate_invoice')">
        <Proforma :groupedLocations="groupedLocations"/>
      </div>
      <div v-if="isAviz && userHasRight('can_generate_aviz')">
        <ManagementAviz :groupedLocations="groupedLocations"/>
      </div>
  </div>
</template>

<script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import Invoice from 'src/components/Dashboard/Views/Invoice/InvoiceDashboard.vue'
  import Proforma from 'src/components/Dashboard/Views/Invoice/Proforma/Proforma.vue'
  import ManagementAviz from 'src/components/Dashboard/Views/Management/Outputs/ManagementAviz.vue'
  import ManagementBonFiscal from 'src/components/Dashboard/Views/Management/Outputs/ManagementBonFiscal.vue'
  export default {
    components: {
      // // GeneralTopBar,
      Invoice,
      Proforma,
      ManagementAviz,
      ManagementBonFiscal
    },
    props: {
      groupedLocations: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        isInvoice: false,
        isProforma: false,
        isAviz: false,
        isBonFiscal: true
      }
    },
    created () {
    },
    methods: {
      openInvoice () {
        this.isInvoice = true
        this.isProforma = false
        this.isAviz = false
        this.isBonFiscal = false
      },
      openProforma () {
        this.isInvoice = false
        this.isProforma = true
        this.isAviz = false
        this.isBonFiscal = false
      },
      openAviz () {
        this.isInvoice = false
        this.isProforma = false
        this.isAviz = true
        this.isBonFiscal = false
      },
      openBonFiscal () {
        this.isInvoice = false
        this.isProforma = false
        this.isAviz = false
        this.isBonFiscal = true
      }
    }
  }
</script>

<style scoped>
.form-check {
display: flex;
gap: 10px;
align-items: flex-start;
}
.action-buttons {
display: flex;
justify-content: space-between;
align-items: center; /* Aliniază butoanele pe axa verticală */
margin-bottom: 15px;
}

.left-buttons {
display: flex;
}

.left-buttons el-button {
margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.button-group {
display: flex; /* Folosește flexbox pentru alinierea orizontală */
justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/ManagementOutputsTabs.vue